exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ui.selection.dropdown.birthday-or-anniversary-event-type-condition {\n  min-width: 250px;\n}\n", ""]);
